import { Injectable } from '@angular/core';

import { RestClient, apiVersion } from '../base/rest-client';

@Injectable()
export class RestClientSystemService extends RestClient {
  /**
   * コンストラクタ
   *
   */
  /**
   * constructor
   *
   */
  constructor() {
    super();
  }
}
